import { CheckCircle } from 'lucide-react';
import { useTenantTheme } from '@/hooks/useTenantTheme';

export default function WelcomeNextSteps() {
  const { logo, isLoading: themeLoading } = useTenantTheme();

  if (themeLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-6 mt-12 bg-white rounded-lg shadow-md">
      <h2 className="text-3xl font-bold mb-6 text-center text-secondary">Thank You for Signing Up!</h2>
      <p className="text-lg text-foreground mb-4 text-center">Here's what to expect next:</p>
      <ul className="space-y-4">
        <li className="flex items-start">
          <CheckCircle className="w-5 h-5 text-success mr-2 mt-1" />
          <span>An email from us allowing you to access the Solerro CRM.</span>
        </li>
        <li className="flex items-start">
          <CheckCircle className="w-5 h-5 text-success mr-2 mt-1" />
          <span>An email from Thryve allowing you to build and design proposals.</span>
        </li>
        <li className="flex items-start">
          <CheckCircle className="w-5 h-5 text-success mr-2 mt-1" />
          <span>An email from Everee allowing us to pay M1s and commissions directly.</span>
        </li>
      </ul>
      <p className="mt-6 text-sm text-gray-600 text-center">If you have any questions, contact us at support@solerro.com.</p>
    </div>
  );
} 